import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_admin/teams/')({
  component: () => <div>Hello /_admin/teams/!</div>,
});

